import React from 'react'

export type LinkingItem<T = object> = {
    _id: string
    type: LinkingItemType
    name: string
    children?: LinkingItem[]
    extras?: { parent: Pick<LinkingItem, '_id' | 'type'> } & T
}

export type LinkedItems = {
    valueMessage?: LinkingItem<{ categoryId: string; narrativeId: string }>[]
    primaryValueMessage?: LinkingItem<{ categoryId: string; narrativeId: string }>[]
    activity?: LinkingItem<{ status: string }>[]
    evidence?: LinkingItem[]
    primaryEvidence?: LinkingItem[]
    strategicImperative?: LinkingItem[]
    keyEvidenceStatement?: LinkingItem[]
    tppCell?: LinkingItem[]
}

export type LinkableItems = LinkedItems

export type LinkingItemsIds = Record<LinkingItemType, LinkingItem['_id'][]>

export type LinkingItemType = keyof LinkedItems

/**
 * Link types that can be shared across roadmaps (currently just Activity, via
 * RoadmapJoinActivity). Reads and writes for these need a roadmapId, since the resource's own
 * strategyId means "owner" only, not "whoever's currently reading or writing." Mirrors
 * ROADMAP_SHARED_MODELS in server/configs/linking-configs.js.
 */
export const ROADMAP_SHARED_LINK_TYPES: LinkingItemType[] = ['activity']

type GroupData = {
    id: string
    name: string
    order: number
    icon?: React.ElementType
}

export type Group<T = object> = GroupData & {
    items: LinkingItem<T>[]
}
